import React, { useRef } from "react";

const InventoryTable = ({ inventoryReportData }: any) => {
  const tableContainerRef = useRef(null);
  const warehouses =
    inventoryReportData?.warehouses?.flatMap(
      (group: any) => group.warehouse_list
    ) || [];

  const grandTotals: Record<
    number,
    {
      qty: number;
      container: number;
      trip: number;
      totalQty: number;
      contractQty: number;
    }
  > = {};

  warehouses.forEach((wh: any) => {
    grandTotals[wh.warehouse_id] = {
      qty: 0,
      container: 0,
      trip: 0,
      totalQty: 0,
      contractQty: 0,
    };
  });

  inventoryReportData?.inventory_report?.forEach((row: any) => {
    row.details.forEach((detail: any) => {
      if (grandTotals[detail.warehouse_id]) {
        grandTotals[detail.warehouse_id].qty += detail.qty ?? 0;
        grandTotals[detail.warehouse_id].container +=
          detail.available_container_qty ?? 0;
        grandTotals[detail.warehouse_id].trip += detail.total_trip_qty ?? 0;
        grandTotals[detail.warehouse_id].totalQty += detail.available_qty ?? 0;
        grandTotals[detail.warehouse_id].contractQty +=
          detail.total_consignment_qty ?? 0;
      }
    });
  });
  // const warehouses = inventoryReportData?.warehouses?.[0]?.warehouse_list || [];

  return (
    <div className="w-full">
      <div
        ref={tableContainerRef}
        className="overflow-x-auto cursor-grab active:cursor-grabbing"
      >
        <table className="min-w-fit border-collapse bg-white border border-gray-300 text-sm text-center">
          {/* HEADER */}
          <thead>
            <tr className="bg-green-800 text-white text-xs">
              <th
                className="sticky left-0 z-20 bg-green-800 px-2 py-2 border"
                rowSpan={2}
              >
                SKU
              </th>
              <th
                className="sticky left-[56px] z-20 bg-green-800 px-2 py-2 border"
                rowSpan={2}
              >
                Code
              </th>
              <th
                className="sticky left-[110px] z-20 bg-green-800 px-2 py-2 border"
                rowSpan={2}
              >
                Description
              </th>
              {warehouses.map((wh: any) => (
                <th
                  key={wh.warehouse_id}
                  colSpan={5}
                  className="px-2 py-2 border"
                >
                  {wh.warehouse_name}
                </th>
              ))}
            </tr>
            <tr className="bg-green-800 text-white text-xs">
              {warehouses.map((wh: any) => (
                <React.Fragment key={wh.warehouse_id}>
                  <th className="px-2 py-2 border">Qty</th>
                  <th className="px-2 py-2 border">Container</th>
                  <th className="px-2 py-2 border">Trip sale</th>
                  <th className="px-2 py-2 border">Total Qty</th>
                  <th className="px-2 py-2 border">Contract Qty</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {inventoryReportData?.inventory_report?.map(
              (row: any, rowIndex: number) => (
                <tr key={rowIndex} className="hover:bg-gray-100">
                  <td className="sticky left-0 z-10 bg-white border px-2 py-2 text-left">
                    {row.unit_name}
                  </td>
                  <td className="sticky left-[56px] z-10 bg-white border px-2 py-2 text-left">
                    {row.product_code}
                  </td>
                  <td className="sticky left-[110px] z-10 bg-white border px-2 py-2 text-left">
                    {row.product_name}
                  </td>
                  {warehouses.map((wh: any) => {
                    const detail = row.details.find(
                      (d: any) => d.warehouse_id === wh.warehouse_id
                    );
                    return (
                      <React.Fragment key={wh.warehouse_id}>
                        <td className="border px-10 py-2 text-red-500">
                          {detail?.qty ?? 0}
                        </td>
                        <td className="border px-10 py-2">
                          {detail?.available_container_qty ?? 0}
                        </td>
                        <td className="border px-10 py-2">
                          {detail?.total_trip_qty ?? 0}
                        </td>
                        <td className="border px-10 py-2">
                          {detail?.available_qty ?? 0}
                        </td>
                        <td className="border px-10 py-2 text-red-500">
                          {detail?.total_consignment_qty ?? 0}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              )
            )}

            {/* Grand Total (Mock values shown, update logic as needed) */}
            <tr className="bg-blue-100 font-semibold">
              <td className="sticky left-0 z-10 bg-blue-100 border px-2 py-2 text-left">
                Total :
              </td>
              <td
                className="sticky left-[56px] z-10 bg-blue-100 border"
                colSpan={2}
              ></td>
              {warehouses.map((wh: any) => {
                const totals = grandTotals[wh.warehouse_id] || {};
                return (
                  <React.Fragment key={wh.warehouse_id}>
                    <td className="border px-2 py-2 text-red-500">
                      {totals.qty}
                    </td>
                    <td className="border px-2 py-2">
                      {totals.container.toFixed(3)}
                    </td>
                    <td className="border px-2 py-2">{totals.trip}</td>
                    <td className="border px-2 py-2">{totals.totalQty}</td>
                    <td className="border px-2 py-2 text-red-500">
                      {totals.contractQty}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InventoryTable;
